var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTucked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_625_4528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6052 -23.0665C23.4379 -25.3436 26.7326 -26.6931 32.8808 -29.5015L39.4095 -26.0966L47.4688 -29.314L61.8382 -24.1286C68.8978 -20.5987 66.7736 -5.44846 68.3668 9.01459C69.2925 17.4175 68.4581 23.0968 67.4297 34.8169L67.0548 41.4081C64.3704 39.5086 62.7906 39.5698 59.9327 40.2835C61.5257 31.8806 60.4815 26.9318 59.058 18.1672C58.8249 9.56375 58.7231 4.72337 57.1525 -3.10563C54.5902 7.0442 54.2738 12.9817 54.8409 23.8212C51.3422 24.6959 45.8782 24.951 39.472 24.977C36.1274 25.1939 32.5168 24.8959 23.0722 23.6338C23.8843 13.3879 27.5391 8.98335 23.9067 -2.10602C23.1271 2.48825 22.0412 5.23483 21.0104 11.7635C20.7293 22.1344 19.3638 24.1594 18.1053 33.255C18.5741 35.8451 19.1974 37.5771 19.9797 40.1585C19.1049 39.3776 13.201 39.5963 12.2327 41.4081L11.5142 34.3171C10.3991 25.335 11.2754 17.2224 12.4524 6.327L12.4826 6.04701C14.7317 -2.13726 14.6068 -17.8498 18.6052 -23.0665Z",
    fill: "white",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.6034 32.4436C64.6663 32.4177 61.8049 29.7009 61.605 29.3511L61.7924 29.9446L62.6358 30.7255L64.0103 32.1L62.2297 31.9126L64.7912 32.4436L67.4152 33.0059L65.6034 32.4436Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.6553 25.2278C14.4423 25.6048 15.9045 26.7164 15.9981 27.0083C14.9421 26.2733 14.4458 25.9963 13.8739 25.9462C13.31 26.1271 12.5908 26.8956 12.4354 27.1145C12.4115 27.1617 12.4007 27.1812 12.4058 27.1645C12.4086 27.1551 12.4188 27.1379 12.4354 27.1145C12.5735 26.8422 13.1503 25.6505 13.6553 25.2278Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.6552 12.2332C13.6861 12.2762 12.9746 12.8104 12.7805 12.9204C13.0095 12.6774 13.1905 12.5601 13.1866 12.2332C13.0032 12.0859 12.912 12.1716 12.7493 12.3269C12.9483 11.9717 13.0627 11.7774 13.499 11.7959C15.6115 12.2701 16.7609 12.6398 18.7157 13.5452C17.0982 13.0625 13.5702 12.1151 13.6552 12.2332Z",
    fill: "black",
    fillOpacity: 0.45,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5033 25.0705C37.535 9.76409 39.2844 -2.60603 38.2847 -25.0659",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4177 33.5985C15.4633 32.7676 13.9173 32.7982 11.5454 34.5668C11.7641 36.8472 12.2239 41.5568 12.2326 41.5016C12.4299 40.259 17.5118 39.0963 19.9796 40.1584C19.2556 37.661 18.8813 36.2603 18.4177 33.5985Z",
    fill: "white",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1825 34.7858C63.024 32.941 64.6108 32.8604 67.3984 34.5983L67.0548 41.4394C64.6174 39.7594 63.0646 39.3627 59.8389 40.3148C60.1238 38.3704 60.2061 37.1139 60.1825 34.7858Z",
    fill: "white",
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 40.5653,
    cy: 6.23445,
    r: 0.437327,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 40.3153,
    cy: 15.6055,
    r: 0.437327,
    fill: "black",
    fillOpacity: 0.6,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M63.6499 8.92066C62.7232 9.94109 60.801 12.0819 60.5262 12.4818C60.3926 12.749 60.1606 13.2383 60.0293 13.5879C59.9646 13.8571 59.9238 14.0075 59.9326 13.9187C59.9398 13.8469 59.9764 13.7288 60.0293 13.5879C60.1467 13.0995 60.3428 12.2201 60.4637 11.6696L63.0876 8.702L59.3704 7.70239L65.1806 8.51457L63.6499 8.92066Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.6364 9.29589C19.331 9.78216 20.0882 10.2407 21.0417 10.5142L20.6981 10.2643L20.3545 10.0144L19.8859 9.45208C20.2614 9.27423 20.5902 9.29283 21.0417 9.29589C20.2736 9.08632 19.7496 9.10391 18.855 9.07722C16.8455 8.18176 15.8876 7.39795 14.0757 6.17212C15.7164 7.56588 16.6608 8.31608 18.6364 9.29589Z",
    fill: "black",
    fillOpacity: 0.3,
    stroke: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1454 52.4999C20.8093 41.8517 20.9257 35.9116 22.9169 25.4856",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5308 52.4998C37.0771 47.189 37.646 44.2984 39.3023 39.2141C40.4733 44.2371 40.874 47.1385 41.0737 52.4998",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6882 51.6144C56.1677 41.0762 55.8799 35.2757 54.8025 25.043",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5881 34.7858C24.0624 31.6757 24.8256 29.5588 26.4596 25.043",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9739 25.4856L38.8442 38.7713C41.3677 33.6939 41.6847 31.1165 41.4552 25.4856",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.145 25.043C52.1184 29.143 53.2954 31.4916 55.6883 33.9001",
    stroke: "#999999",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8024 21.5V25.0429H42.8453H36.2024H22.4739V21.5H36.2024H42.8453H54.8024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.031 25.0429H22.4739M22.4739 25.0429V21.5H36.2024M22.4739 25.0429H36.2024M36.2024 21.5V25.0429M36.2024 21.5H42.8453M36.2024 25.0429H42.8453M42.8453 21.5H54.8024V25.4857V25.0429H42.8453M42.8453 21.5V25.0429",
    stroke: "#999999",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_625_4528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTucked);
export default __webpack_public_path__ + "static/media/tucked.c335c48753eccc83834626a56295d46c.svg";
export { ForwardRef as ReactComponent };